import cookie from '@/services/cookie'
import UserAdsCampaignApi from '@/api/userAdsCampaign'
import { PUBLIC_ROUTES } from '@/constant/routes'

const USER_ADS_COOKIES = 'aha-ads'

// State
const _state = {

}

// Getters
const _getters = {

}

// Mutations
const mutations = {

}

function getAdsInformationFromQueryString(firstUrlQueryString = null) {
  if (!firstUrlQueryString) {
    firstUrlQueryString = window.location.search
  }
  const utmInformation = new URLSearchParams(firstUrlQueryString)
  if (utmInformation.toString() === '') {
    return null
  }
  const adsInformation = Object.fromEntries(utmInformation)
  if (!adsInformation.utm_campaign) {
    return null
  }
  return adsInformation
}

function getAdsInformationsFromCookies() {
  const adsInformationFromCookie = cookie.getValue(USER_ADS_COOKIES)
  if (!adsInformationFromCookie) {
    cookie.deleteValue(USER_ADS_COOKIES)
    return null
  }
  return JSON.parse(adsInformationFromCookie)
}

// Actions
const actions = {
  shouldIgnoreEUAndPublicRoute({ rootState, rootGetters }) {
    return PUBLIC_ROUTES.includes(rootState.route.name) || rootGetters.isEURegion
  },
  async handleUsersAdsCampaignAction({ rootState, dispatch }, firstUrlQueryString) {
    if (!rootState.currentUser) {
      dispatch('saveUserAdsCampaignToCookies', firstUrlQueryString)
    } else {
      // delay 5s
      await new Promise((resolve) => setTimeout(resolve, 5000))
      dispatch('saveUserAdsCampaignToSystem', firstUrlQueryString)
    }
  },
  async saveUserAdsCampaignToCookies(firstUrlQueryString) {
    const adsInformation = getAdsInformationFromQueryString(firstUrlQueryString)
    if (!adsInformation) {
      return
    }
    const adsInformations = cookie.getValue(USER_ADS_COOKIES)
    if (adsInformations) {
      adsInformations.push(adsInformation)
      cookie.setValue(USER_ADS_COOKIES, JSON.stringify(adsInformations))
    } else {
      cookie.setValue(USER_ADS_COOKIES, JSON.stringify([adsInformation]))
    }
  },
  async saveUserAdsCampaignToSystem({ dispatch }, firstUrlQueryString) {
    const shouldIgnoreEUAndPublicRoute = await dispatch('shouldIgnoreEUAndPublicRoute')
    if (shouldIgnoreEUAndPublicRoute) return
    const adsInformation = getAdsInformationFromQueryString(firstUrlQueryString)
    if (adsInformation) {
      UserAdsCampaignApi.saveUserAdsCampaign({
        utmInformation: JSON.stringify(adsInformation),
      })
    }
    const adsInformationsFromCookies = getAdsInformationsFromCookies()
    if (!adsInformationsFromCookies) {
      return
    }
    adsInformationsFromCookies.forEach((adsInformationFromCookies) => {
      if (!adsInformationFromCookies.utm_campaign) {
        return
      }
      UserAdsCampaignApi.saveUserAdsCampaign({
        utmInformation: JSON.stringify(adsInformationFromCookies),
      })
    })
    cookie.deleteValue(USER_ADS_COOKIES)
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
